if (!customElements.get('sunpura-in-box')) {
  customElements.define('sunpura-in-box', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.variants = JSON.parse(this.querySelector('[data-box-variants]').textContent);
      const options = {capture:true, signal:this.controller.signal};
      document.addEventListener('sunpura:variant-rendered', event => {
        if (event.target.dataset.productId === this.dataset.productId) this.sync(event.target);
      }, options);
      const product = [...document.querySelectorAll('product-info')].find(el => el.dataset.productId === this.dataset.productId);
      if (product) this.sync(product);
    }
    sync(product) {
      const node = product.querySelector('variant-selects [data-selected-variant]');
      if (!node) return;
      let variant;
      try {variant = JSON.parse(node.textContent);} catch {return;}
      const entry = this.variants.find(item => String(item.id) === String(variant?.id));
      const capacity = Number.parseFloat((entry?.capacity || '').replace(',', '.'));
      if (![2.4,4.8,7.2,9.6].includes(capacity)) return;
      const count = Math.round(capacity / 2.4);
      const panel = this.querySelector('.sp-box__configuration');
      const changed = this.capacity !== undefined && this.capacity !== capacity;
      this.capacity = capacity;
      this.querySelector('[data-box-capacity]').textContent = new Intl.NumberFormat(this.dataset.locale || 'en', {minimumFractionDigits:1, maximumFractionDigits:1}).format(capacity);
      this.querySelector('[data-box-batteries]').textContent = count;
      this.querySelectorAll('[data-box-quantity]').forEach(el => {el.textContent = Number(el.dataset.base) + count * Number(el.dataset.perBattery);});
      const image = this.querySelector('.sp-box__figure img');
      if (image && entry.image && image.getAttribute('src') !== entry.image) {
        image.removeAttribute('srcset');
        image.src = entry.image;
      }
      if (changed && this.dataset.motion !== 'false' && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        panel.getAnimations().forEach(animation => animation.cancel());
        panel.animate([{opacity:.6},{opacity:1}], {duration:180,easing:'ease-out'});
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.querySelectorAll('*').forEach(el => el.getAnimations().forEach(animation => animation.cancel()));
    }
  });
}
